import { Fancybox } from '@fancyapps/ui';

export function initFancybox() {
  // Prevents Rollup from removing Fancybox by tree shaking
  Fancybox.bind('[data-fancybox]', {});
}
